import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "detail_container"
}
const _hoisted_2 = { class: "detail_base-info card-white-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "detail_header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "基本信息")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_5 = { class: "hw_detail_table_header" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "card-white-6 hw_detail_table_container"
}

import { edit_ugs_recharge_account, get_ugs_recharge_apply_item } from '@/api/ugs-openAccount';
  import { BasicColumn, BasicTableProps } from '@/components/WeTable';
  import { useApp } from '@/hooks/useApp';
  import { useAppInfo } from '@/hooks/useAppInfo';
  import { useJump } from '@/hooks/useJump';
  import { formatNumberByNumeral, isEmptyData } from '@/utils/common';
  import { cloneDeep } from 'lodash-es';
  import { ref, computed, reactive, unref } from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  props: {
    id: { default: -1 }
  },
  setup(__props: any) {

const props = __props as { id: string | number }

   // TAB.WAITING

  const { jumpToCompany, jumpToContract, jumpToOpenAccountAuditDetail } = useJump();
  const { $message } = useApp();
  const { model } = useAppInfo();
  const editMode = ref(false);
  const detail_data = ref<Recordable>({});
  const account_table_list = ref<Recordable[]>([]);
  const editableData = reactive<Recordable>({});
  const show_edit_account_button = computed(() => {
    return !editMode.value;
  });
  const left_amount_list = computed<Recordable[]>(() => {
    if (isEmptyData(detail_data.value.credit)) {
      return [];
    }
    const account_list = detail_data.value.account_list || [];
    const contract_property_list = account_list.map((item) => item.contract_property);
    return detail_data.value.credit
      .filter((f) => contract_property_list.includes(f.property))
      .map((item) => ({
        label: `${model.value.Contract.CONTRACT_PROPERTY[item.property]}授信余额`,
        amount: formatNumberByNumeral(item.credit_info.left_credit_limit, '0,0.00'),
        max_overdue_days_label: `${model.value.Contract.CONTRACT_PROPERTY[item.property]}逾期天数`,
        to_collect_overdue_label: `${model.value.Contract.CONTRACT_PROPERTY[item.property]}逾期金额`,
        ...item.credit_info,
      }));
  });
  const columns = computed<BasicColumn[]>(() => [
    { title: '账户ID', dataIndex: 'account_id', slots: { customRender: 'account_id' } },
    { title: '开户代理', dataIndex: 'account_agency_name' },
    { title: '客户合同', dataIndex: 'contract_name', slots: { customRender: 'contract_name' } },
    { title: '客户商务', dataIndex: 'contract_owner_name' },
    { title: '客户运营', dataIndex: 'contract_am_name' },
    { title: '申请充值金额(USD)', dataIndex: 'apply_amount' },
    { title: '实际充值金额(USD)', dataIndex: 'recharge_amount', slots: { customRender: 'recharge_amount' } },
  ]);
  const account_table_config = computed<BasicTableProps>(() => {
    return { columns: columns.value, immediate: false, showTableHeader: false, useSearchForm: false };
  });
  const edit_account_list = (dataList) => {
    if (!editMode.value) {
      dataList.forEach((item) => {
        editableData[item.id] = cloneDeep(item);
      });
    } else {
      dataList.forEach((item) => {
        delete editableData[item.id];
      });
    }
    editMode.value = !editMode.value;
  };
  const save_account_list = (index) => {
    const account_list: Recordable[] = [];
    account_table_list.value.forEach((item, i) => {
      if (index === i) {
        account_list.push(...(Object.values(unref(editableData)) as any));
        item.account_list.forEach((f) => {
          delete editableData[f.id];
        });
      } else {
        account_list.push(...item.account_list);
      }
    });
    editMode.value = false;
    const params = {
      apply_id: props.id,
      account_list,
    };
    edit_ugs_recharge_account(params)
      .then(() => {
        $message.success('编辑成功');
      })
      .catch(() => {
        $message.error('编辑失败');
      })
      .finally(() => {
        editMode.value = false;
        init_data();
      });
  };
  const init_data = () => {
    account_table_list.value = [];
    get_ugs_recharge_apply_item({ apply_id: Number(props.id) }).then((res) => {
      detail_data.value = res;
      document.title = detail_data.value.name;
      const normal_list = res.account_list.filter(
        (item) => item.contract_property === model.value.Contract.CONTRACT_PROPERTY.NORMAL
      );
      const prepay_list = res.account_list.filter(
        (item) => item.contract_property === model.value.Contract.CONTRACT_PROPERTY.PREPAY
      );
      account_table_list.value.push({
        title: 'Normal账号列表',
        account_list: normal_list,
      });
      account_table_list.value.push({
        title: 'Prepay账号列表',
        account_list: prepay_list,
      });
    });
  };
  init_data();

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!

  return (_openBlock(), _createBlock(_component_page_detail_wrapper, _mergeProps(_ctx.$attrs, {
    collapsed: true,
    title: detail_data.value.name
  }), {
    default: _withCtx(() => [
      (!_unref(isEmptyData)(detail_data.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_a_form, {
                model: detail_data.value,
                ref: (_value, _refs) => {
                  _refs['detail_from_ref'] = _value
                }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    gutter: 20,
                    type: "flex",
                    style: {"flex-wrap":"wrap"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "客户名称",
                            name: "name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: detail_data.value.company.name,
                                edit: false
                              }, {
                                text: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "link",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(jumpToCompany)(detail_data.value.company.id))),
                                    style: {"white-space":"pre-wrap"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(detail_data.value.company.name), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "简称",
                            name: "short_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: detail_data.value.company.short_name,
                                edit: false
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(left_amount_list), (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: item.label
                        }, [
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: item.label,
                                name: "amount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: item.amount,
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: item.max_overdue_days_label,
                                name: "max_overdue_days"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: item.max_overdue_days,
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_a_col, {
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: item.to_collect_overdue_label,
                                name: "to_collect_overdue"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: item.to_collect_overdue,
                                    edit: false
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ]),
                            _: 2
                          }, 1024)
                        ], 64))
                      }), 128)),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "媒体平台",
                            name: "platform"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: detail_data.value.platform,
                                edit: false
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "联系人邮箱",
                            name: "email"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: detail_data.value.email,
                                edit: false
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "申请时间",
                            name: "create_time"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: detail_data.value.create_time,
                                edit: false
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "充值类型",
                            name: "recharge_type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: detail_data.value.recharge_type,
                                edit: false
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "提交人",
                            name: "rd_applicant_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: detail_data.value.rd_applicant_name,
                                edit: false
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_unref(isEmptyData)(detail_data.value.opa_apply))
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "开户申请",
                                name: "name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: detail_data.value.create_time,
                                    edit: false
                                  }, {
                                    text: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "link",
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(jumpToOpenAccountAuditDetail)(detail_data.value.opa_apply)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(detail_data.value.opa_apply.name), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(account_table_list.value, (account_config, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (!_unref(isEmptyData)(account_config.account_list))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(account_config.title), 1),
                        _createElementVNode("span", null, [
                          (_unref(show_edit_account_button))
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "primary",
                                onClick: ($event: any) => (edit_account_list(account_config.account_list))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_a_button, {
                                  onClick: ($event: any) => (edit_account_list(account_config.account_list))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_8
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  onClick: ($event: any) => (save_account_list(index))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_9
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ], 64))
                        ])
                      ]),
                      _createVNode(_component_a_table, _mergeProps(_unref(account_table_config), {
                        dataSource: account_config.account_list
                      }), {
                        account_id: _withCtx(({ record }) => [
                          _createElementVNode("span", null, _toDisplayString(record.ml_account.account_id), 1)
                        ]),
                        contract_name: _withCtx(({ record, text }) => [
                          _createVNode(_component_a_button, {
                            type: "link",
                            onClick: ($event: any) => (_unref(jumpToContract)({ id: record.contract_id }))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(text), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        recharge_amount: _withCtx(({ text, record }) => [
                          (!editMode.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(text), 1))
                            : (_openBlock(), _createBlock(_component_a_input_number, {
                                key: 1,
                                value: _unref(editableData)[record.id].recharge_amount,
                                "onUpdate:value": ($event: any) => ((_unref(editableData)[record.id].recharge_amount) = $event)
                              }, null, 8, ["value", "onUpdate:value"]))
                        ]),
                        _: 2
                      }, 1040, ["dataSource"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            (!_unref(isEmptyData)(detail_data.value.flow))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_FlowTimeLine, {
                    flow: detail_data.value.flow,
                    onOnUpdate: init_data
                  }, null, 8, ["flow"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["title"]))
}
}

})